module.exports = __webpack_public_path__ + "img/call.73d7ef24.svg";